module.exports = __webpack_public_path__ + "static/media/canon-mobile-2.85703135.jpg";